import { useMemo } from 'react';
import { useBounds } from '../useBounds';
import { getViewportTypeFromWidth } from '../useBounds/getViewport';

type Return = {
  isSmallViewport: boolean;
  isMediumViewport: boolean;
  isLargeViewport: boolean;
  isStable: boolean;
};

export const useViewport = (): Return => {
  const { width } = useBounds();

  return useMemo(() => {
    if (width === 0) {
      return {
        isSmallViewport: true,
        isMediumViewport: false,
        isLargeViewport: false,
        isStable: false,
      };
    }

    const viewportType = getViewportTypeFromWidth(width);

    return {
      isSmallViewport: viewportType === 'small',
      isMediumViewport: viewportType === 'medium',
      isLargeViewport: viewportType === 'large',
      isStable: true,
    };
  }, [width]);
};
